import React from "react";
import { useTranslation } from "react-i18next";
import BlockButton from "../components/block-button";
declare var DataActivationController: any;
const GenericError = () => {
  const closeWebsheet = () => {
    const dataActivationController = DataActivationController;
    // @ts-ignore
    if (DataActivationController) {
      // @ts-ignore
      dataActivationController.doneSelected();
    } else {
      console.error("DataActivationController not found");
    }
  };

  const { t } = useTranslation();
  return (
    <div className="layout-default">
      <h2 className="layout-default-left watch-title">
        {t("We could not activate your watch at this time")}
      </h2>
      <p>{t("Try again later or call Customer Service at 1-877-512-0911.")}</p>

      <BlockButton
        onClick={closeWebsheet}
        dataTestId="close-button"
        text={t("CLOSE")}
      />
    </div>
  );
};

export default GenericError;
